// Configuração dinâmica da API baseada no ambiente
const getApiConfig = () => {
  // Se estiver rodando em desenvolvimento local
  if (
    process.env.NODE_ENV === 'development' && 
    window.location.hostname === 'localhost'
  ) {
    return {
      baseURL: 'http://localhost:3001',
      isLocal: true
    };
  }
  
  // Se estiver em produção (Vercel) ou outros ambientes
  return {
    baseURL: '',  // URLs relativas para produção
    isLocal: false
  };
};

export const API_CONFIG = getApiConfig();

// Helper para construir URLs da API
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.baseURL}${endpoint}`;
};

// Log da configuração em desenvolvimento
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 API Config:', API_CONFIG);
}